Object.defineProperty(exports, "__esModule", { value: true });
exports.ANGULAR_ROUTING_OP = 'ui.angular.routing';
exports.ANGULAR_INIT_OP = 'ui.angular.init';
exports.ANGULAR_OP = 'ui.angular';
//# sourceMappingURL=constants.js.map